<template>
    <guest-invoices-setup-base-card v-if="reservation && housekeeping" class="guest-invoices-setup-second-card">
        <template v-slot:card-body>
            <b-row>
                <b-col>
                    <b>BEGINS:</b>
                </b-col>
                <b-col cols="auto">
                    <span v-if="!reservationEdit">
                        <span class="mr-1">
                            {{ fromDateDisplayValue }}
                            <b class="ml-1">at</b>
                        </span>
                        <span> {{ beginsDisplayValue }} </span>
                    </span>
                    <span v-else-if="begins.isEdit && selectedCell === 'begins' && reservationEdit">
                        {{ fromDateDisplayValue }}
                        <b class="ml-1">at</b>
                        <b-timepicker
                            ref="begins"
                            v-click-outside="handleBeginsOutsideClick"
                            class="guest-invoices-setup-second-card__timepicker"
                            v-model="reservation.check_in"
                            :hour12="twelveHourFormat"
                            minutes-step="5"
                            no-close-button
                        />
                    </span>
                    <span v-else>
                        <span class="mr-1">
                            {{ fromDateDisplayValue }}
                            <b class="ml-1">at</b>
                        </span>
                        <span
                            type="button"
                            class="text-primary guest-invoices-setup-base-card__clickable-cell"
                            @click="editCellHandler('begins')"
                        >
                            {{ beginsDisplayValue }}
                        </span>
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b>ENDS:</b>
                </b-col>
                <b-col cols="auto">
                    <span v-if="!reservationEdit">
                        <span class="mr-1">
                            {{ toDateDisplayValue }}
                            <b class="ml-1">at</b>
                        </span>
                        <span> {{ endsDisplayValue }} </span>
                    </span>
                    <span v-else-if="ends.isEdit && selectedCell === 'ends' && reservationEdit">
                        {{ toDateDisplayValue }}
                        <b class="ml-1">at</b>
                        <b-timepicker
                            ref="ends"
                            v-click-outside="handleEndsOutsideClick"
                            class="guest-invoices-setup-second-card__timepicker"
                            v-model="reservation.check_out"
                            :hour12="twelveHourFormat"
                            minutes-step="5"
                            no-close-button
                        />
                    </span>
                    <span v-else>
                        <span class="mr-1">
                            {{ toDateDisplayValue }}
                            <b class="ml-1">at</b>
                        </span>
                        <span
                            type="button"
                            class="text-primary guest-invoices-setup-base-card__clickable-cell"
                            @click="editCellHandler('ends')"
                        >
                            {{ endsDisplayValue }}
                        </span>
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b>LENGTH:</b>
                </b-col>
                <b-col class="text-right">
                    <span class="mr-1">{{ reservation.length }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col><b>INVOICE NOTES:</b></b-col>
            </b-row>
            <b-row>
                <b-col>
                    <span v-if="!reservationEdit">
                        {{ reservation.notes }}
                        <span v-if="!reservation.notes" class="text-danger"> None </span>
                    </span>
                    <b-form-textarea
                        ref="invoiceNotes"
                        v-click-outside="handleInvoiceNotesOutsideClick"
                        v-else-if="invoiceNotes.isEdit && selectedCell === 'invoiceNotes' && reservationEdit"
                        type="text"
                        v-model="reservation.notes"
                    />
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-setup-base-card__clickable-cell"
                        @click="editCellHandler('invoiceNotes')"
                    >
                        {{ reservation.notes }}
                        <span v-if="!reservation.notes" class="text-danger"> None </span>
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col><b>ARRIVAL NOTES:</b></b-col>
            </b-row>
            <b-row>
                <b-col>
                    <span v-if="!reservationEdit">
                        {{ housekeeping.comments }}
                        <span v-if="!housekeeping.comments" class="text-danger"> None </span>
                    </span>
                    <b-form-textarea
                        ref="arrivalNotes"
                        v-click-outside="handleArrivalNotesOutsideClick"
                        v-else-if="arrivalNotes.isEdit && selectedCell === 'arrivalNotes' && reservationEdit"
                        type="text"
                        v-model="housekeeping.comments"
                    />
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-setup-base-card__clickable-cell"
                        @click="editCellHandler('arrivalNotes')"
                    >
                        {{ housekeeping.comments }}
                        <span v-if="!housekeeping.comments" class="text-danger"> None </span>
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col><b>DEPARTURE NOTES:</b></b-col>
            </b-row>
            <b-row>
                <b-col>
                    <span v-if="!reservationEdit">
                        {{ housekeeping.departure_comments }}
                        <span v-if="!housekeeping.departure_comments" class="text-danger"> None </span>
                    </span>
                    <b-form-textarea
                        ref="departureNotes"
                        v-click-outside="handleDepartureNotesOutsideClick"
                        v-else-if="departureNotes.isEdit && selectedCell === 'departureNotes' && reservationEdit"
                        type="text"
                        v-model="housekeeping.departure_comments"
                    />
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-setup-base-card__clickable-cell"
                        @click="editCellHandler('departureNotes')"
                    >
                        {{ housekeeping.departure_comments }}
                        <span v-if="!housekeeping.departure_comments" class="text-danger"> None </span>
                    </span>
                </b-col>
            </b-row>
        </template>
    </guest-invoices-setup-base-card>
</template>

<script>
import { mapGetters } from 'vuex';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import API from '../../../../../api.jsx';
import { BVFormBtnLabelControl } from 'bootstrap-vue/src/components/form-btn-label-control/bv-form-btn-label-control';
import { GUEST_RESERVATION_ENDPOINT } from '../../../../../endpoints.js';
import { formatResponseError } from '../../../../../utils/api.js';
import GuestInvoicesSetupBaseCard from './base-card.vue';

export default {
    name: 'GuestInvoicesSetupSecondCard',
    components: {
        BVFormBtnLabelControl,
        GuestInvoicesSetupBaseCard,
    },
    data() {
        return {
            begins: { previous: null, isEdit: false },
            ends: { previous: null, isEdit: false },
            invoiceNotes: { previous: null, isEdit: false },
            arrivalNotes: { previous: null, isEdit: false },
            departureNotes: { previous: null, isEdit: false },
        };
    },
    inject: ['showSuccessToast', 'showErrorToast'],
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation', 'housekeeping']),
        ...mapGetters('header', ['userUnicodeDateFormat', 'userTimeFormat']),
        guestId() {
            return parseInt(this.$route.params.id);
        },
        reservationId() {
            return parseInt(this.$route.query.reservation);
        },
        reservationEdit() {
            return this.metadata?.permissions?.reservation_edit;
        },
        twelveHourFormat() {
            return this.userTimeFormat === 'hh:mm a';
        },
        beginsDisplayValue() {
            return this.formatTime(this.reservation.check_in);
        },
        endsDisplayValue() {
            return this.formatTime(this.reservation.check_out);
        },
        fromDateDisplayValue() {
            if (this.reservation.from_date)
                return format(parseISO(this.reservation.from_date), this.userUnicodeDateFormat);
            return '';
        },
        toDateDisplayValue() {
            if (this.reservation.to_date) return format(parseISO(this.reservation.to_date), this.userUnicodeDateFormat);
            return '';
        },
    },
    methods: {
        formatTime(time) {
            if (time) return format(parse(time, 'HH:mm:ss', new Date()), this.userTimeFormat);
            return '';
        },
        handleOutsideClick(event) {
            this.begins.isEdit = false;
            this.ends.isEdit = false;
            this.invoiceNotes.isEdit = false;
            this.arrivalNotes.isEdit = false;
            this.departureNotes.isEdit = false;
            this.selectedCell = null;
        },
        handleBeginsOutsideClick(event) {
            this.begins.isEdit = false;
            this.selectedCell = null;
            this.handleBeginsChange();
        },
        handleEndsOutsideClick(event) {
            this.ends.isEdit = false;
            this.selectedCell = null;
            this.handleEndsChange();
        },
        handleInvoiceNotesOutsideClick(event) {
            this.invoiceNotes.isEdit = false;
            this.selectedCell = null;
            this.handleInvoiceNotesChange();
        },
        handleArrivalNotesOutsideClick(event) {
            this.arrivalNotes.isEdit = false;
            this.selectedCell = null;
            this.handleArrivalNotesChange();
        },
        handleDepartureNotesOutsideClick(event) {
            this.departureNotes.isEdit = false;
            this.selectedCell = null;
            this.handleDepartureNotesChange();
        },
        editCellHandler(name) {
            this.handleOutsideClick();
            this[name].isEdit = true;
            this.selectedCell = name;
            if (name == 'begins') this.showBegins();
            if (name == 'ends') this.showEnds();
            if (name == 'invoiceNotes') this.showInvoiceNotes();
            if (name == 'arrivalNotes') this.showArrivalNotes();
            if (name == 'departureNotes') this.showDepartureNotes();
        },
        showBegins() {
            this.begins.previous = this.reservation.check_in;
            this.$nextTick(() => {
                this.$refs.begins.$children[0].show();
            });
        },
        showEnds() {
            this.ends.previous = this.reservation.check_out;
            this.$nextTick(() => {
                this.$refs.ends.$children[0].show();
            });
        },
        showInvoiceNotes() {
            this.invoiceNotes.previous = this.reservation.notes;
            this.$nextTick(() => {
                this.$refs.invoiceNotes.focus();
            });
        },
        showArrivalNotes() {
            this.arrivalNotes.previous = this.housekeeping.comments;
            this.$nextTick(() => {
                this.$refs.arrivalNotes.focus();
            });
        },
        showDepartureNotes() {
            this.departureNotes.previous = this.housekeeping.departure_comments;
            this.$nextTick(() => {
                this.$refs.departureNotes.focus();
            });
        },
        async handleBeginsChange() {
            const previous = this.begins.previous;
            const newBegins = this.reservation.check_in;
            try {
                this.$emit('loading', true);
                if (newBegins != previous) {
                    await API.patch(GUEST_RESERVATION_ENDPOINT(this.reservationId, this.guestId), {
                        check_in: newBegins,
                    });
                    this.showSuccessToast({
                        text: 'Begins successfully updated.',
                    });
                }
            } catch (e) {
                this.reservation.check_in = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change begins.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleEndsChange() {
            const previous = this.ends.previous;
            const newEnds = this.reservation.check_out;
            try {
                this.$emit('loading', true);
                if (newEnds != previous) {
                    await API.patch(GUEST_RESERVATION_ENDPOINT(this.reservationId, this.guestId), {
                        check_out: newEnds,
                    });
                    this.showSuccessToast({
                        text: 'Ends successfully updated.',
                    });
                }
            } catch (e) {
                this.reservation.check_out = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change ends.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleInvoiceNotesChange() {
            const previous = this.invoiceNotes.previous;
            const newInvoiceNotes = this.reservation.notes;
            try {
                this.$emit('loading', true);
                if (newInvoiceNotes != previous) {
                    await API.patch(GUEST_RESERVATION_ENDPOINT(this.reservationId, this.guestId), {
                        notes: newInvoiceNotes,
                    });
                    this.showSuccessToast({
                        text: 'Invoice notes successfully updated.',
                    });
                }
            } catch (e) {
                this.reservation.notes = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change invoice notes.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleArrivalNotesChange() {
            const previous = this.arrivalNotes.previous;
            const newArrivalNotes = this.housekeeping.comments;
            try {
                this.$emit('loading', true);
                if (newArrivalNotes != previous) {
                    await API.patch(GUEST_RESERVATION_ENDPOINT(this.reservationId, this.guestId), {
                        comments: newArrivalNotes,
                    });
                    this.showSuccessToast({
                        text: 'Arrival notes successfully updated.',
                    });
                }
            } catch (e) {
                this.housekeeping.comments = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change arrival notes.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleDepartureNotesChange() {
            const previous = this.departureNotes.previous;
            const newDepartureNotes = this.housekeeping.departure_comments;
            try {
                this.$emit('loading', true);
                if (newDepartureNotes != previous) {
                    await API.patch(GUEST_RESERVATION_ENDPOINT(this.reservationId, this.guestId), {
                        departure_comments: newDepartureNotes,
                    });
                    this.showSuccessToast({
                        text: 'Departure notes successfully updated.',
                    });
                }
            } catch (e) {
                this.housekeeping.comments = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change departure notes.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.guest-invoices-setup-second-card {
    &__timepicker {
        min-width: 12rem;
    }
}
</style>
